import styled from 'styled-components';
import Login from './Login';
import { media, colorSchema } from 'utils/style';

export default styled(Login)`
  height: 100%;
  .login {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(4, 1fr);
    flex-direction: column;
    height: 100%;
    max-width: 1440px;
    margin: 0 auto;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(14, 1fr);
    `}

    &__container {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        grid-column: 6 / span 4;
        grid-row: 1;
        padding: 2rem 0;
      `}
    }

    &__logo {
      display: flex;
      justify-content: center;
      margin-bottom: 1.6rem;

      svg {
        fill: ${colorSchema('primary')};
      }
    }

    &__title {
      font-size: 3.2rem;
      font-weight: normal;
      line-height: 1.19;
      margin: 0;
      margin-bottom: 2.4rem;
      text-align: center;
    }

    &__error {
      color: ${colorSchema('error700')};
    }

    &__loading {
      display: flex;
      justify-content: center;
    }

    &__recovery {
      color: ${colorSchema('primary')};
      display: flex;
      font-size: 1.6rem;
      font-weight: 500;
      margin: 3rem 0;
      justify-content: center;

      &:hover {
        text-decoration: underline;
      }
    }

    &__error {
      background-color: ${colorSchema('error100')};
      border: 1px solid ${colorSchema('error500')};
      border-radius: 4px;
      color: ${colorSchema('error900')};
      display: flex;
      font-size: 1.4rem;
      font-weight: 500;
      max-width: 320px;
      margin-bottom: 1.6rem;
      padding: 1.6rem;
      width: 100%;
    }
  }
`;
